import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";

import {v4 as uuidv4} from 'uuid';

import { useCookies } from 'react-cookie';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Navigation } from 'swiper/modules';


import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Slider from '@mui/material/Slider';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InfoIcon from '@mui/icons-material/Info';
import SendIcon from '@mui/icons-material/Send';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Avatar from '@mui/material/Avatar';
import ReimoSwiper from "../components/ReimoSwiper";

import Header from "./common/Header2";

import Alert from "../dialogs/Alert";
import DisplayImage from "../dialogs/DisplayProductImage";
import RequestOffer from "../dialogs/RequestOffer";
import RequestConfig from "../dialogs/RequestConfig";

import ContactPersons from "../widgets/ContactPersons";
import ModelCard from "../widgets/ModelCard";
import ModelCardOwnConfig from "../widgets/ModelCardOwnConfig";
import ModelProductCard from "../widgets/ModelProductCard";
import ModelDesignCard from "../widgets/ModelDesignCard";
import ProductRoofCard from "../widgets/ProductRoofCard";
import BaseCarCard from "../widgets/BaseCarCard";

import articles from '../db/articles.json';


import {formatNumber, getExternal, calcMonth, getConfigurationCode, calcTotal} from "../helper/utils";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

const newConfig =  await getConfigurationCode();


function  ConfigureContent(props) {
	var models = require('../db/models.json');	
  	const getCar = (which) => {
		let car;
		models.cars.forEach((value, keys) => {
			if(value.url == which)
		  		car = value;
	  })
	  return car;
  	};
	console.log("ConfigureContent");
	console.log(props.props.model);
	let model = getCar(props.props.model);



	const prepareConfig = () => {	
		let configStore = [];
		
		for (const [key, value] of Object.entries(model.configuration)) {
			let o = {};				
			o.label = key;		
			let v = [];				
			value.forEach((value1, k1) => {
				let o1 = {};				
				let v1 = [];
				let myuuid = uuidv4();
				if(value1.default)
					v1.push(value1.default);				
				value1.uuid = myuuid;
				o1.label = value1.label;
				o1.uuid = myuuid;
				o1.id = value1.id;
				o1.widget = value1.widget;
				o1.items = v1;
				v.push(o1);
	
		  	})
			o.cluster = v;
			configStore.push(o);
	
		}	
		return configStore;
	}		
	
	const { t, i18n } = useTranslation("",{lng: props.language});

	const [internalConfiguration, setInternalConfiguration] = React.useState(prepareConfig);
	const [displayAlert, setDisplayAlert] = React.useState(false);
	const [displayImage, setDisplayImage] = React.useState(false);
	const [item, setItem] = React.useState(null);
	const [displayAlertMsg, setDisplayAlertMsg] = React.useState("");
	const [activeStep, setActiveStep] = React.useState(0);
	const [extCode, setExtCode] = React.useState("");
	const [externalConfiguration, setExternalConfiguration] = React.useState(null);
  	const [skipped, setSkipped] = React.useState(new Set());
	const [furnitureDecor, setFurnitureDecor] = React.useState("roof_option_12.jpg");
	const [basePlate, setBasePlate] = React.useState("roof_option_12.jpg");
	const [carFinal, setCarFinal] = React.useState(model.imagePlain);
	const [currentRoof, setCurrentRoof] = React.useState("");
	const [currentPad, setCurrentPad] = React.useState("");
	const [currentFloor, setCurrentFloor] = React.useState("");
	const [whichConfiguration, setWhichConfiguration] = React.useState("");
	const [currentReimoOptions, setCurrentReimoOptions] = React.useState(new Map());
	const [carPrice, setCarPrice] = React.useState(0);
  	const [config, setConfig] = React.useState(newConfig.result);
	const [requestOffer, setRequestOffer] = React.useState(false);
	const [requestConfig, setRequestConfig] = React.useState(false);
	const [userConfig, setUserConfig] = React.useState();
  	const [openBD, setOpenBD] = React.useState(false);
	const [expansionVariant, setExpansionVariant] = React.useState("true");

	const [duration, setDuration] = React.useState(120);
	const [downPayment, setDownPayment] = React.useState(25);
	const [cookies, setCookie] = useCookies(['config']);

	const steps = [t("Grund Fahrzeug"),  t("Sonderausstattungen"), t("Schlafdach"), t("Zubehör"), t("Innen Design"), t("Zusammenfassung")];
	
	let navigate = useNavigate();

	const handleShowExpansion = (value, url) => {
		navigate("/configureexpansion/" + url + "/");

	};

  	const handleChangeDuration = (event, newValue, activeThumb) => {
		setDuration(newValue);
  	};

  	const handleChangeDownPayment = (event, newValue, activeThumb) => {
		setDownPayment(newValue);
  	};

  	const handleCloseBD = () => {
    	setOpenBD(false);
  	};
  	
  	const handleOpenBD = () => {
    	setOpenBD(true);
  	}; 

	function getItems(id) {				
		let reimoOptions = [];
		internalConfiguration[id].cluster.forEach(cluster  => {
			cluster.items.map(item  => {
				let optionObj = {};
				optionObj.label = articles[item].label;
				optionObj.price = formatNumber("de_DE", articles[item].price);
				reimoOptions.push(optionObj);
			});
		});
		return reimoOptions;
	};


	const callUrl = (url) => {
		if(url == "requestOffer")
			setRequestOffer(true);
		if(url == "requestConfig") {
			let carOptions = [];
			externalConfiguration.data[0].vehicle_configuration.options.forEach(option => {
				if(option.description) {
					let optionObj = {};
					optionObj.label = option.description;
					optionObj.price = formatNumber("de_DE", option.price);
					carOptions.push(optionObj);
				}		
			});


			let sections = [];
			let section = {};
			section.label = "Basisfahrzeug";
			section.baseCar = model.baseModel;
			section.price = formatNumber("de_DE", carPrice);	
			section.options = carOptions;
			sections.push(section);

			let section1 = {};
			section1.label = "Grund Fahrzeug Extras";
			section1.options = getItems(0);
			section1.price = formatNumber("de_DE", Number(calcCluster(0)));	
			sections.push(section1);

			let section2 = {};
			section2.label = "Dach";
			section2.options = getItems(1);
			section2.price = formatNumber("de_DE", Number(calcCluster(1)));	
			sections.push(section2);

			let section3 = {};
			section3.label = "Zubehör";
			section3.options = getItems(2);
			section3.price = formatNumber("de_DE", Number(calcCluster(2)));	
			sections.push(section3);

			let section4 = {};
			section4.label = "Dekor";
			section4.options = getItems(3);
			section4.price = formatNumber("de_DE", Number(calcCluster(3)));	
			sections.push(section4);
			
			let obj = {};
			obj.sections = sections;
			obj.model = props.props.model;
			obj.exteriorColor = returnSpecialValue(0, "exteriorColor");
			obj.furnitureDecor = returnSpecialValue(3, "furnitureDecor");
			obj.basePlate = returnSpecialValue(3, "basePlate");
			obj.upholsteryFabric = returnSpecialValue(3, "upholsteryFabric");
			
			
			obj.pricetotal = formatNumber("de_DE",carPrice + Number(calcCluster(0)) + Number(calcCluster(1)) + Number(calcCluster(2)) + Number(calcCluster(3)) );			
			obj.downPayment = formatNumber("de_DE", (carPrice + Number(calcCluster(0)) + Number(calcCluster(1)) + Number(calcCluster(2))  + Number(calcCluster(3)) ) / 100 * downPayment );			
			obj.nettoPrice = formatNumber("de_DE", ((carPrice + calcCluster(0) + calcCluster(1) +calcCluster(2 +calcCluster(3)) - (carPrice + Number(calcCluster(0)) + Number(calcCluster(1)) + Number(calcCluster(2))  + Number(calcCluster(3)) ) / 100 * downPayment )));			
			obj.monthlyRate = calcMonth(((carPrice + calcCluster(0) + calcCluster(1) +calcCluster(2 +calcCluster(3)) - (carPrice + Number(calcCluster(0)) + Number(calcCluster(1)) + Number(calcCluster(2))  + Number(calcCluster(3)) ) / 100 * downPayment )), duration);
			obj.grossSum = calcTotal(((carPrice + calcCluster(0) + calcCluster(1) +calcCluster(2 +calcCluster(3)) - (carPrice + Number(calcCluster(0)) + Number(calcCluster(1)) + Number(calcCluster(2))  + Number(calcCluster(3)) ) / 100 * downPayment )), duration);
			obj.downPaymentPercent = downPayment;
			obj.durationMonth = duration;
			obj.transferCosts = formatNumber("de_DE", model.transferCosts);
			setUserConfig(obj);
			setRequestConfig(true);
			
		}
	};
	
	const handleItem = (e, uuid, id) => {
		let sC = structuredClone(internalConfiguration);
		sC.forEach((v, k) => {		
			v.cluster.forEach((v1, k1) => {						
				if(v1.uuid == uuid) {
					if(v1.widget == "mandatorySingleChoice" || v1.widget == "mandatorySingleChoiceProductCard" || v1.widget == "mandatorySingleChoiceColor") {
						let oo = [];
						oo.push(id);					
						v1.items = oo

					}
					if(v1.widget == "singleChoice" || v1.widget == "singleChoiceColor"  || v1.widget == "singlechoiceProductCard"  || v1.widget == "singlechoiceRoofCard") {
						let oo = [];
						if(e.target.checked === true)
							oo.push(id);					
						v1.items = oo
					}
					
					if(v1.widget == "multiChoice" || v1.widget == "multiChoiceProductCard") {
						if(e.target.checked === true)
							v1.items.push(id);					
						else {
							let oo = [];
							v1.items.forEach((v2, k2) => {
								if(v2 != id)
									oo.push(v2);
							});						
							v1.items = oo
						}										
					}
				}
			});
		});
		setInternalConfiguration(sC);
	};


	const isStepOptional = (step) => {
	    return step === 19;
	  };

  	const isStepSkipped = (step) => {
    	return skipped.has(step);
  	};
  	
  	async function getNewCode() {
		const newConfig =  await getConfigurationCode();
		setConfig(newConfig.result);
	 };
  	

  	const handleNext = () => {
		setCookie('config', config);
    	let newSkipped = skipped;
    	if (isStepSkipped(activeStep)) {
      		newSkipped = new Set(newSkipped.values());
      		newSkipped.delete(activeStep);
    	}

		if(activeStep == 0 && whichConfiguration == "") {
			setDisplayAlert(true);
			setDisplayAlertMsg("Sie müssen ein Fahrzeug auswählen");
		}
		else {
			window.scrollTo(0, 0);
			getNewCode();

	    	setActiveStep((prevActiveStep) => prevActiveStep + 1);
	    	setSkipped(newSkipped);
	    }
  	};

  	const handleImageDisplay = (item) => {
		setItem(item);
    	setDisplayImage(true)
 	};

  	const handleBack = () => {
    	setActiveStep((prevActiveStep) => prevActiveStep - 1);
		window.scrollTo(0, 0);
  	};

  	const handleSkip = () => {
    	if (!isStepOptional(activeStep)) {
      		throw new Error("You can't skip a step that isn't optional.");
    	}

    	setActiveStep((prevActiveStep) => prevActiveStep + 1);
    	setSkipped((prevSkipped) => {
      		const newSkipped = new Set(prevSkipped.values());
      		newSkipped.add(activeStep);
      		return newSkipped;
    	});
  	};

  	const handleReset = () => {
		window.scrollTo(0, 0);
    	setActiveStep(0);
  	};
  	

  	const changeCarColorFloor = (carImage) => {
		setCarFinal(carImage);
  	};

  	const changeReimoOption = (e, reimoOption) => {
	  	var tmp = new Map(currentReimoOptions);
		if((tmp.has(reimoOption.artnr)))
			tmp.delete(reimoOption.artnr);
		else
			tmp.set(reimoOption.artnr, reimoOption);
		setCurrentReimoOptions(tmp);
  	};

  	const changeFloor = (e, carFloor) => {
		if(e.target.checked == false) {
			setCurrentFloor("");			
		}
		else {
			setCurrentFloor(carFloor);			
		}
  	};
  	
  	const changePad = (e, carPad) => {
		if(e.target.checked == false) {
			setCurrentPad("");			
		}
		else {
			setCurrentPad(carPad);			
		}
  	};

  	
  	const changeConfiguration = (e, which, extCode, producer) => {
		try {
			if(e.target.checked && e.target.checked == false) {
				setWhichConfiguration("");			
				setExtCode("");
			}
			else {
				if(which == "internal") {
					getExternalId(extCode,  producer, "internal");
				}
				setWhichConfiguration(which);
			}
		}			
		catch (error) {
			setWhichConfiguration("");	
			setExtCode("");
		
		}			
	};

	async function getExternalId(_extCode, producer, _which) {
		setOpenBD(true);
		let data = await getExternal(_extCode, producer);
		setOpenBD(false);	    	

		if(data.error_message) {
			setDisplayAlert(true);
			setDisplayAlertMsg(data.error_message);
			setExtCode("");
		}
		else {
			let tCarPrice = 0;
			data.data[0].vehicle_configuration.options.map(option => {
				if(!isNaN(option.price))
					tCarPrice += option.price;
			});		
			setWhichConfiguration(_which);
			setCarPrice(tCarPrice);
			setExternalConfiguration(data);
		}
  	};  	

  	function printReimoOption(value) {
		return (<Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
		        	<Typography gutterBottom variant="h6" component="div">
		            	{value.label}
		          	</Typography>
		          	<Typography gutterBottom variant="h6" component="div">
			            {formatNumber("de_DE", value.price)}
		          	</Typography>
		        </Stack>)
	}

  	function calcReimoAddonPrice() {
		let treimoAddonPrice = 0;
		if(currentRoof != "")
			treimoAddonPrice = Number(currentRoof.price);
		for (const [key, value] of currentReimoOptions) { 
		    if(!isNaN(value.price))
		    	treimoAddonPrice += Number(value.price);	
		}
		return treimoAddonPrice;
	}
  	
  	function printReimoOptions() {
		let html = [];
		for (const [key, value] of currentReimoOptions) { 
		    html.push( printReimoOption(value));
		}
		return html;
	}
  	
  	function widgetFactory(obj) {
		if(obj.widget == "singleChoice" || obj.widget == "mandatorySingleChoice")
			return renderSingleChoice(obj);	
		else if(obj.widget == "singleChoiceColor"  || obj.widget == "mandatorySingleChoiceColor")
			return renderSingleChoiceColor(obj);	
		else if(obj.widget == "multiChoice")
			return renderSingleChoice(obj);	
		else if(obj.widget == "singlechoiceProductCard" || obj.widget == "mandatorySingleChoiceProductCard" || obj.widget == "multiChoiceProductCard")
			return returnSinglechoiceProductCard(obj);	
			
	}
		
	function isChecked(uuid, id) {
		let checked = false;
		internalConfiguration.forEach((v, k) => {		
			v.cluster.forEach((v1, k1) => {						
				if(v1.uuid == uuid) {
					v1.items.forEach((v2, k2) => {
						if(v2 == id)
							checked = true;
					});						
				}
			});
		});		
		return checked;
	}

  	function renderSingleChoice (obj) {
		return 	<>	
					<h3>{obj.label}</h3>
						{obj.items.map((item)  => (
					        <Stack  className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
								<Typography style={{paddingLeft: "10px"}} gutterBottom variant="h6" component="div">
									<FormControlLabel
									  label={articles[item.refId].label}
									  control={
										<Checkbox 	data-type="carRoofs" 
													onClick={e => handleItem(e, obj.uuid, item.refId)}
													checked={isChecked(obj.uuid, item.refId)}
										/>	
									}
								/>
								{articles[item.refId].src != null ? (
									<>
										<span onClick={e => handleImageDisplay(articles[item.refId])}><InfoIcon /></span>
									</>) :
									(<></>)
								}
								</Typography>
							    <Typography gutterBottom variant="h6" component="div">
								   	<nobr>{formatNumber("de_DE", articles[item.refId].price)}</nobr>
					          	</Typography>																			          
							</Stack>	
						))}
				</>
	}
	
  	function returnSpecialValue (id, type) {
		let result = "";
		try {
			internalConfiguration[id].cluster.forEach((v1, k) => {
				if(v1.id == type) {		
					v1.items.forEach((v2, k2) => {
						 result = articles[v2].src;
					});						
				}
			});
		}
		catch (error) {
		}		
		return result;
	}

  	function renderSingleChoiceColor (obj) {
		return 	<>	
					<h3>{obj.label}</h3>
						{obj.items.map((item)  => (
							<>
			        		<Grid item xs={12} sx={{marginTop: "10px"}}>
					      		<Grid container spacing={2}>
					        		<Grid item xs={1}>
										<Avatar sx={{width: "48px", height: "48px", border: "1px solid #000", backgroundColor: "#fff"}} alt={articles[item.refId].label} src={"/assets/article-images/" + articles[item.refId].src} />
									</Grid>
					        		<Grid item xs={11}>							
								        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">						        	
												<FormControlLabel
												  label={articles[item.refId].label}
												  control={
													<Checkbox 	data-type="carRoofs" 
																onClick={e => handleItem(e, obj.uuid, item.refId)}
																checked={isChecked(obj.uuid, item.refId)}
													/>	
												}
											/>
											</Typography>
										    <Typography gutterBottom variant="h6" component="div">
											   	<nobr>{formatNumber("de_DE", articles[item.refId].price)}</nobr>
								          	</Typography>																			          
										</Stack>	
									</Grid>
								</Grid>
							</Grid>
							
							</>
						))}
				</>
	}

  	function returnSinglechoiceProductCard (obj) {
		return 	<>	
					<h3>{obj.label}</h3>
					<Grid container spacing={2}>
							{obj.items.map((item)  => (
								<Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
									<ModelDesignCard 	item={articles[item.refId]} 
														changeItem={handleItem} 
														uuid={obj.uuid} 
														currentArtnr={item.refId} 
														checked={isChecked(obj.uuid, item.refId)}/>																		  
								</Grid>
							))}

					</Grid>	
				</>
	}

	function calcCluster(id) {
		let sum = 0;
		try {
			internalConfiguration[id].cluster.forEach((v1, k) => {		
					v1.items.forEach((v2, k2) => {
						sum += articles[v2].price;
					});						
			});
		}
		catch (error) {
		}		
		return sum;
	};

	function renderCluster(id) {
		return 	<>	
				{internalConfiguration[id].cluster.map((cluster)  => (
					<>
						{cluster.items.length > 0 ? (<>
							<h3>{cluster.label}</h3>
							{cluster.items.map((item)  => (
								<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
									<Typography gutterBottom variant="h6" component="div" style={{paddingLeft: "10px"}}>
										  {articles[item].label}																			
									</Typography>
								    <Typography gutterBottom variant="h6" component="div">
									   <nobr>	{formatNumber("de_DE", articles[item].price)}</nobr>
						          	</Typography>
								</Stack>
							))}
						</>):(<></>)}
					</>
				))}
				</>
	};


	function renderItems(id) {
		return 	<>	
				{internalConfiguration[id].cluster.map((cluster)  => (
					<>
						{cluster.items.length > 0 ? (<>
							{cluster.items.map((item)  => (
								<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
									<Typography gutterBottom variant="h6" component="div">
										  {articles[item].label}																			
									</Typography>
								    <Typography gutterBottom variant="h6" component="div">
									   	<nobr>{formatNumber("de_DE", articles[item].price)}</nobr>
						          	</Typography>
								</Stack>
							))}
						</>):(<></>)}
					</>
				))}
				</>
	};
		

	
	function renderSmallSumUp(model) {
		return <Paper className="stickyConfigurationSumUp" sx={{marginTop: "60px"}}>
					<Box>	
						<Box sx={{paddingLeft: "8px", backgroundColor: "rgb(43, 108, 176) !important",minHeight: "40px", lineHeight: "40px", color: "white"}}>
							{t("IhreAuswahl")}
						</Box>	
						<Box sx={{paddingLeft: "8px", paddingRight: "8px", paddingBottom: "8px"}}>
							<Box sx={{alignItems: "center"}}>	
								<center>
						      	<img height="120"
						        	 src={model.imagePlain}		        			
						      	/>	
								</center>
							</Box>	
					      	<hr/>
					      	
							<Accordion sx={{boxShadow1: "none"}}>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
   						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Basisfahrzeug")}<br/>{model.baseModel}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", carPrice)}</nobr>
		
						          			</Typography>																			          
										</Stack>	
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Nachlass")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									        {model.discount && model.showDiscount == "true" ? (
												<>
									   			<nobr>&nbsp;-{formatNumber("de_DE", (carPrice /100 * model.discount))}</nobr>
									 		</>
										) :(<></>)
											}			
						          			</Typography>																			          
										</Stack>	
									</Box>	
						        </AccordionSummary>
						        <AccordionDetails>															        
							    	{externalConfiguration.data[0].vehicle_configuration.options.map(option =>(
										<>
											{option.description ? (																						
												<Stack className="" direction="row" justifyContent="space-between" alignItems="center">
										       		<Typography gutterBottom variant="h6" component="div">{option.description}</Typography>
										          	<Typography gutterBottom variant="h6" component="div">
											            <nobr>{formatNumber("de_DE", option.price)}</nobr>

										          	</Typography>
							        			</Stack>
											) :(<></>)
											}																			
										</>
									))}	
						        </AccordionDetails>
							</Accordion>					      	
							<Accordion sx={{boxShadow1: "none"}}>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Sonderausstattung")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(0))}</nobr>
						          			</Typography>																			          
										</Stack>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Nachlass")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
											            {model.discount && model.showDiscount == "true" ? (
												<>
									   			<nobr>&nbsp;-{formatNumber("de_DE", (calcCluster(0) /100 * model.discount))}</nobr>
									 		</>
										) :(<></>)
											}			
						          			</Typography>																			          
										</Stack>									</Box>	
						        </AccordionSummary>
						        <AccordionDetails>
							        {renderItems(0)}															        
						        </AccordionDetails>
							</Accordion>					      	
							<Accordion sx={{boxShadow1: "none"}}>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Dach")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(1))}</nobr>
						          			</Typography>																			          
										</Stack>
									</Box>	
						        </AccordionSummary>
						        <AccordionDetails>
							        {renderItems(1)}															        
						        </AccordionDetails>
							</Accordion>					      	
							<Accordion sx={{boxShadow1: "none"}}>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Zubehör")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(2))}</nobr>
						          			</Typography>																			          
										</Stack>	
									</Box>
						        </AccordionSummary>
						        <AccordionDetails>															        
							        {renderItems(2)}															        
						        </AccordionDetails>
							</Accordion>					      	
							<Accordion>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Dekor")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(3))}</nobr>
						          			</Typography>																			          
										</Stack>
									</Box>	
						        </AccordionSummary>
						        <AccordionDetails>															        
							        {renderItems(3)}															        
						        </AccordionDetails>
							</Accordion>					      	
						</Box>	
						<Box sx={{paddingLeft: "8px", paddingRight: "8px", backgroundColor: "rgb(237, 242, 247) !important",minHeight: "40px", lineHeight: "40px"}}>
					        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
								<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
									{t("Zwischensumme")}
							 	</Typography>
							    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
								   	{formatNumber("de_DE", (calcCluster(0) + calcCluster(1) +calcCluster(2) + calcCluster(3) + carPrice) )}
					          	</Typography>																			          
							</Stack>	
							
							{model.discount && model.showDiscount == "true" ? (
						        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
									<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
										{t("Nachlass")}
								 	</Typography>
								    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
										{formatNumber("de_DE", ((calcCluster(0) + carPrice) /100 * model.discount))}
						          	</Typography>																			          
								</Stack>	

										) :(<></>)
							}			
							{model.discount && model.showDiscount == "true" ? (
						        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
									<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
										{t("Ihr Preis")}
								 	</Typography>
								    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
										{formatNumber("de_DE", ((calcCluster(0) + calcCluster(1) +calcCluster(2) + calcCluster(3) + carPrice) - (calcCluster(0) + carPrice) /100 * model.discount))}
						          	</Typography>																			          
								</Stack>	

										) :(<></>)
							}			
					        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
								<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
									{t("zzglÜberführung")}
							 	</Typography>
							    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
								   	{formatNumber("de_DE", model.transferCosts)}
					          	</Typography>																			          
							</Stack>	
					        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
								<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
									{t("Gesamtpreis")}
							 	</Typography>
							    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
								   	{formatNumber("de_DE", (((calcCluster(0) + calcCluster(1) +calcCluster(2) + calcCluster(3) + carPrice) - (calcCluster(0) + carPrice) /100 * model.discount) + parseFloat(model.transferCosts)) )}
					          	</Typography>																			          
							</Stack>	
						</Box>
					</Box>	
				</Paper>		
	}	
	
	
  	
  	return (<>
				{model != undefined ? (<>
				   			<Alert display={displayAlert} displayAlertMsg={displayAlertMsg} setDisplayAlert={setDisplayAlert}/>

				<Box sx={{ flexGrow: 1, display: {
							xs: 'block',
							sm: 'block',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  
							
							} }}
				>
	  				<Box sx={{paddingTop: "0px"}}> 
						<Header setLanguage={props.props.setLanguage} heroImages={model.heroImages} label={model.producerLabel  + " "+  model.label} slogan={t("KonfigureDescription")} breadcrumb={props.props.breadcrumb} embedded={props.props.embedded}/>




		  				<Box sx={{paddingTop: "0px", display: expansionVariant == "true" ? "block" : "none"}}> 


						<Grid container style={{paddingTop: "40px"}}>
			        		<Grid item xs={12}>
					      		<Grid container spacing={2}>
					        		<Grid item xs={1}>
						     	   </Grid>
					        		<Grid item xs={10} >
										<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}} >
											<Box  style={{color: "#000"}}>
												<center>
													{t("Wählen Sie bitte Ihre Ausbauvariante aus")}<br/>
												</center>
											</Box>			
											<Box sx={{marginTop: "20px"}}>
											    <ReimoSwiper
											        height="460px"
											        slidesPerView={3}
											        spaceBetween={30}
											        loop={false}
											        resetOnChildrenChange={true}
											
											    >
													{model.family.map((url) => (
											        	<SwiperSlide>
															<BaseCarCard url={url} model={getCar(url)} handleShowExpansion={handleShowExpansion}/>
											        	</SwiperSlide>
												 	))}
												 	
												</ReimoSwiper>		
					
											</Box>										
										</Box>	
						     	   	</Grid>
					        		<Grid item xs={1}>
						     	   </Grid>
					     	   </Grid>
				     	   </Grid>
			     	   	</Grid>


						</Box>
			  				<Box sx={{paddingTop: "40px"}}> 
								<ContactPersons/>
							</Box>


					</Box>
					
					<RequestOffer open={requestOffer} handleOpen={setRequestOffer} config={config} car={props.props.model}/>
					<RequestConfig open={requestConfig} handleOpen={setRequestConfig} config={config} car={props.props.model} userConfig={userConfig}/>
			      	<Backdrop
				        sx={{ color: '#fff', zIndex: 8000 }}
				        open={openBD}
				        onClick={handleCloseBD}
				      >
				        <CircularProgress color="inherit" />
				    </Backdrop>      			
	   				<DisplayImage display={displayImage}  setDisplayImage={setDisplayImage} item={item}/>

   			</Box>
   		</>):( <>
   			   </>)
   		}
)
   			
   		</>
   	)
}

export default function ConfigurePage(props) {

  return <ConfigureContent props={props}/>;
}